module.exports = function() {
    $('.pulsepoint-header-open-button').click(function() {
        var $header = $(this).parents('.pulsepoint-header');
        $header.toggleClass('pulsepoint-header-open');
        return false;
    });
};